import { createCommands } from 'utils/commands';
export const copilotDropdownCommands = createCommands([
    {
        group: 'richTextEditor',
        label: 'Translate selected text',
        name: 'translate',
        description: 'Translates the selected text in the editor',
    },
    {
        group: 'richTextEditor',
        label: 'Check spelling and grammar',
        name: 'checkSpellingAndGrammar',
        description: 'Checks the spelling and grammar of selected text in the editor',
    },
]);
